import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditStatusModalComponent } from './edit-status-modal.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {DropdownModule} from "@xref/xref-lib";

@NgModule({
  declarations: [EditStatusModalComponent],
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DropdownModule
  ],
  exports: [EditStatusModalComponent]
})
export class EditStatusModalModule { }
